import React from 'react';
import EditableCell from '../TariffTable/components/EditableCell';
import { ITariff } from '../../../../../interfaces/tariff';
import { TariffEditFields } from '../../../../../store/ducks/tariff.duck';

const EditableCellTariff: React.FC<{
  tariff: ITariff;
  editable: boolean;
  loading: boolean;
  success: boolean;
  fieldValue: keyof ITariff;
  field: TariffEditFields;
  submit: (id: number, field: TariffEditFields, value: string | number | null) => void;
}> = ({ tariff, editable, loading, success, field, fieldValue, submit }) => {
  if (fieldValue === 'distance_fee') return null;
  return (
    <EditableCell
      cell={{
        value: tariff[fieldValue] || 0,
        field,
        text: tariff[fieldValue] || 0,
      }}
      loading={loading}
      success={success}
      submit={newValue => {
        const numValue = newValue ? Number(newValue) : 0;
        submit(tariff.id, field, Number.isNaN(numValue) ? 0 : numValue);
      }}
      editable={editable}
    />
  );
};

export default EditableCellTariff;
